module.exports = __webpack_public_path__ + "img/luntan.73d99c88.png";